module.exports = __webpack_public_path__ + "img/banner_bancos.165c3bc1.jpg";